import * as React from "react";
import { FormStatus } from "./constants";

const SUCCESS_MSG = `Thank you for reaching out to us. We will get back to you as soon as
      possible.`;

const FAILED_MSG = `We are sorry, something went wrong while submitting your request. Please,
      try again later.`;

export const Alert = ({ formStatus }) => {
  const isSuccess = formStatus === FormStatus.success;
  const isFailed = formStatus === FormStatus.failed;

  const successContent = (
    <div className="bg-success/10 border border-success rounded py-4 px-5 mb-8">
      {SUCCESS_MSG}
    </div>
  );

  const failedContent = (
    <div className="bg-red-500/10 border border-red-500 rounded py-4 px-5 mb-8">
      {FAILED_MSG}
    </div>
  );

  let content = null;
  if (isSuccess) content = successContent;
  if (isFailed) content = failedContent;

  return content;
};
